<script lang="ts" setup>
import { inject, ref, onBeforeUnmount, onMounted } from 'vue';
import { Viewer, ViewerEvents } from '@immersive-tech/viewer-engine';

import type { Ref } from 'vue';
import type { SceneInfo, Extension, Nullable } from '@immersive-tech/viewer-engine';

const viewer = inject('viewer') as Ref<Nullable<Viewer>>;
const frames = ref(0);
const drawCalls = ref(0);
const vertices = ref(0);
const sceneInfoExtension = viewer.value?.extensions.get('SceneInfo') as Extension<SceneInfo>;

const viewerPostRenderEventHandler = () => {
  vertices.value = Math.trunc(viewer.value?.scene?.getTotalVertices() ?? 0);
  frames.value += 1;
  drawCalls.value = sceneInfoExtension.sceneInfo?.drawCallsCounter.current ?? 0;
};

const mountHandler = () => {
  if (!viewer.value) return;

  viewer.value.addEventListener(ViewerEvents.VIEWER_POST_RENDER, viewerPostRenderEventHandler);
};

const unmountHandler = () => {
  viewer.value?.removeEventListener(ViewerEvents.VIEWER_POST_RENDER, viewerPostRenderEventHandler);
};

onMounted(mountHandler);
onBeforeUnmount(unmountHandler);
</script>

<template>
  <div class="absolute bottom-[5px] right-[5px] flex flex-col font-mono bg-white/50 border p-1 text-xs leading-none">
    <div class="flex flex-row">
      <span>frame:</span>
      <span>{{ frames.toLocaleString('en-US') }}</span>
    </div>
    <div class="flex flex-row">
      <span>draw calls:</span>
      <span>{{ drawCalls.toLocaleString('en-US') }}</span>
    </div>
    <div class="flex flex-row">
      <span>vertices:</span>
      <span>{{ vertices.toLocaleString('en-US') }}</span>
    </div>
  </div>
</template>
